<template>
  <div class="monitor-container container-view" ref="pageView">
    <!-- title -->
    <!--
      <section class="title-section">
      <p class="titleInfo fl">{{ curTime }}</p>
      <p
        class="titleText"
        :style="{ backgroundImage: `url(${homeTitle})` }"
      ></p>
      <p class="fullScreen fr" @click="fullScreen" title="全屏">
        <i
          :class="[
            isFullScreen
              ? 'e6-icon-screen-half_line'
              : 'e6-icon-screen-full_line'
          ]"
        ></i>
      </p>
    </section>
    -->
    <section class="main">
      <section class="chartPanel">
        <!--topLeft-->
        <!-- <div class="chartPanel-child topLeft" v-loading="topLeftLoading">
          <ul class="chartPanel-child-slide">
            <li
              v-for="(item, index) in topLeftTimelineData"
              :key="item"
              :class="{ active: index === topLeftTimelineActiveIndex }"
              @click="topLeftChartTimelineProgressChange(index)"
            >
              {{ item }}
            </li>
          </ul>
          <div class="chartPanel-child-chartArea" ref="topLeftChartDOM"></div>
        </div> -->
        <!--topCenter-->
        <div class="chartPanel-child topCenter">
          <div class="center-middle-wrap">
            <ul class="dataBubbleList">
              <router-link class="dataBubble" to="/baseComparyList" tag="li">
                <p class="dataBubble__header">入驻企业总数</p>
                <div class="dataBubble__content">
                  {{ topTotalNumber.comparyNum }}
                </div>
              </router-link>
              <router-link
                v-if="$GLOBAL_CONFIG.imageDirName === 'zhengzhou'"
                class="dataBubble"
                to="/baseComparyList"
                tag="li"
              >
                <p class="dataBubble__header">今日新增企业数</p>
                <div class="dataBubble__content">
                  {{ topTotalNumber.addComparyNum }}
                </div>
              </router-link>
              <router-link
                class="dataBubble"
                to="/monitCenterVehicleList"
                tag="li"
              >
                <p class="dataBubble__header">车辆总数</p>
                <div class="dataBubble__content">
                  {{ topTotalNumber.coldStorageVehicleNum }}
                </div>
              </router-link>
              <router-link
                class="dataBubble"
                to="/monitCenterStorageList"
                tag="li"
              >
                <p class="dataBubble__header">冷库总数</p>
                <div class="dataBubble__content">
                  {{ topTotalNumber.storageNum }}
                </div>
              </router-link>
              <router-link class="dataBubble" to="/baseFreezerList" tag="li">
                <p class="dataBubble__header">冷柜总数</p>
                <div class="dataBubble__content">
                  {{ topTotalNumber.freezerNum }}
                </div>
              </router-link>
            </ul>
            <!--middleCenter-->
            <div
              class="chartPanel-child middleCenter"
              ref="mapChartDOM"
              v-loading="mapLoading"
            ></div>
          </div>
        </div>
        <!--topRight-->
        <div class="chartPanel-child topRight" v-loading="topRightLoading">
          <ul class="chartPanel-child-slide">
            <li
              v-for="(item, index) in topRightTimelineData"
              :key="item"
              :class="{ active: index === topRightTimelineActiveIndex }"
              @click="topRightChartTimelineProgressChange(index)"
            >
              {{ item }}
            </li>
          </ul>
          <div class="chartPanel-child-chartArea" ref="topRightChartDOM"></div>
        </div>
        <!--middleLeft-->
        <!-- <div
          ref="middleLeftChartDOM"
          class="chartPanel-child middleLeft"
          v-loading="middleLeftLoading"
        ></div> -->
        <!--middleRight-->
        <div
          ref="middleRightChartDOM"
          class="chartPanel-child middleRight"
          v-loading="middleRightLoading"
        ></div>
        <!--bottomLeft-->
        <!-- <div
          ref="bottomLeftChartDOM"
          class="chartPanel-child bottomLeft"
          v-loading="bottomLeftLoading"
        ></div> -->
        <!--bottomCenter-->
        <section class="chartPanel-child bottomCenter">
          <el-carousel
            height="100%"
            :interval="15000"
            indicator-position="none"
          >
            <el-carousel-item v-for="(value, name) in tableObj" :key="name">
              <table class="chartPanel__table">
                <thead>
                  <tr class="th-color">
                    <th>地区</th>
                    <th>企业</th>
                    <th>车辆</th>
                    <th>冷库</th>
                    <th>冷柜</th>
                  </tr>
                </thead>
                <tbody>
                  <tr v-for="(item, index) in value" :key="index">
                    <td class="th-color">{{ item.areaName }}</td>
                    <td>{{ item.comparyNum }}</td>
                    <td>{{ item.vehicleNum }}</td>
                    <td>{{ item.storageNum }}</td>
                    <td>{{ item.freezerNum }}</td>
                  </tr>
                </tbody>
              </table>
            </el-carousel-item>
            <!-- <el-carousel-item v-if="tableData2.length > 0">
              <table class="chartPanel__table">
                <thead>
                  <tr class="th-color">
                    <th>地区</th>
                    <th>企业</th>
                    <th>车辆</th>
                    <th>冷库</th>
                    <th>冷柜</th>
                  </tr>
                </thead>
                <tbody>
                  <tr v-for="(item, index) in tableData2" :key="index">
                    <td class="th-color">{{ item.areaName }}</td>
                    <td>{{ item.comparyNum }}</td>
                    <td>{{ item.vehicleNum }}</td>
                    <td>{{ item.storageNum }}</td>
                    <td>{{ item.freezerNum }}</td>
                  </tr>
                </tbody>
              </table>
            </el-carousel-item> -->
          </el-carousel>
        </section>
        <!--bottomRight-->
        <div
          ref="bottomRightChartDOM"
          class="chartPanel-child bottomRight"
          v-loading="bottomRightLoading"
        ></div>
      </section>
    </section>
  </div>
</template>

<script>
// plugin
import moment from "moment";
import Echarts from "echarts";
import ECStat from "echarts-stat";
import { mapGetters, mapMutations } from "vuex";

// 顶部中间平台名称图片
const homeTitle = require(`@/assets/images/${$GLOBAL_CONFIG.imageDirName}/home-title.png`);

// mixins
// import resizeListener from "_private/mixins/resizeListener";

// interface
import {
  FetchNumberByRealTime,
  FetchNumberByAreaName,
  FetchCountNumMonth,
  FetchOnlineAndQualifyRateByDay,
  FetchCompanyNumAndRate,
  // FetchCompanyOnlineAndQualifyTop3,
  FetchCompanyNumAndRateByAreaName,
  FetchVehicleOrStorageOnline,
  FetchMap,
  FetchCompanyInfoByCity
} from "@/api/home/home.js";

// charts setting
import { converData, handleMapData, handleCityData } from "./chartConfig.js";

export default {
  // mixins: [resizeListener],
  data() {
    return {
      homeTitle: Object.freeze(homeTitle), // 顶部中间平台名称图片
      curTime: moment().format("YYYY-MM-DD HH:mm:ss"),
      timeInterval: null, // 时间显示定时器
      resizeTimer: null, // resize事件节流timer
      clientWidth: document.documentElement.clientWidth, // 页面宽度
      clientHeight: document.documentElement.clientHeight, // 页面高度
      reloadDataTime: 1000 * 60 * 60, // 刷新数据时间间隔

      /************ topLeft ****************/
      topLeftChartInstance: null, // 左上角图表实例
      topLeftLoading: false, // 左上角数据正在加载
      topLeftChartData: [],
      topLeftAutoHighlightTimer: null,
      topLeftTimelineData: ["企业", "冷库", "冷柜", "车"],
      topLeftTimelineActiveIndex: 0,

      /*********** topRight ********************/
      topRightChartInstance: null, // 右上角图表实例
      topRightLoading: false, // 右上角数据正在加载
      topRightChartData: [],
      topRightAutoHighlightTimer: null,
      topRightTimelineData: ["在线率", "温度合格率"],
      topRightTimelineActiveIndex: 0,

      /*********** middleLeft ********************/
      middleLeftFetchDataTimer: null, // 获取数据计时器
      middleLeftChartInstance: null, // 中部左侧图表实例
      middleLeftLoading: false, // 中部左侧数据正在加载
      middleLeftChartData: [],

      /*********** middleRight ********************/
      middleRightChartInstance: null, // 中部右侧图表实例
      middleRightLoading: false, // 中部右侧数据正在加载
      middleRightChartData: {
        areaNameList: [],
        onlineRateList: [],
        qualifyRateList: []
      },
      middleRightTimelineData: ["在线率"],
      middleRightTimelineActiveIndex: 0,
      middleRightAutoHighlightTimer: null,

      /*********** bottomLeft ********************/
      bottomLeftFetchDataTimer: null,
      bottomLeftChartInstance: null, // 左下角图表实例
      bottomLeftLoading: false, // 左下角数据正在加载
      bottomLeftChartData: [],
      bottomLeftAutoHighlightTimer: null,

      /*********** bottomRight ********************/
      bottomRightChartInstance: null, // 右下角图表实例
      bottomRightLoading: false, // 右下角数据正在加载
      bottomRightChartData: {
        areaNameList: [],
        onlineRateList: [],
        qualifyRateList: []
      },
      bottomRightAutoHighlightTimer: null,

      /************* centerMap ********************/
      mapChartInstance: null, // 地图图表实例
      mapOutlineGeo: {}, // 地图地区外轮廓geo数据
      mapGuangdongOutlineGeo: {}, // 广东的地图 geo 数据
      mapChartData: {
        companyList: [],
        freezerList: [],
        storageList: []
      },
      mapChartHighlightTimer: null,
      vehicleNumData: [],
      topTotalNumber: {
        // 顶部总数据项展示
        comparyNum: 0, // 企业个数
        addComparyNum: 0, //今日新增企业数
        coldStorageVehicleNum: 0, // 冷藏车总数
        storageNum: 0, // 冷库总数
        freezerNum: 0 // 冷柜总数
      },
      tableData1: [],
      tableData2: [],
      tableObj: {},
      mapLoading: false,
      chartTimer: null,
      bottomRightAnimation: null, // 右下角图表 tooltip 定时器
      bottomLeftAnimation: null, // 左下角图表 tooltip 定时器
      topLeftAnimation: null, // 左上角 tooltip 定时器
      topRightAnimation: null, // 右上角 tooltip 定时器

      isGoDown: true // 是否下钻地图
    };
  },

  created() {
    this.initCenterMap(); // 初始化中间地图geo数据，获取业务数据
  },

  mounted() {
    this.setCLockTimeInterval();
    this.reloadData();
  },

  beforeDestroy() {
    clearInterval(this.timeInterval); // 清除定时器
    clearInterval(this.chartTimer);
  },

  computed: {
    ...mapGetters(["isFullScreen"])
  },

  methods: {
    ...mapMutations(["updateFullScreen"]),
    // 全屏
    fullScreen() {
      this.updateFullScreen();
    },

    // 设置左上角钟表定时器
    setCLockTimeInterval() {
      clearInterval(this.timeInterval);
      // 设置定时器，每个1秒获取一次时间信息
      this.timeInterval = setInterval(() => {
        this.curTime = moment().format("YYYY-MM-DD HH:mm:ss");
      }, 1000);
    },

    // // 监控浏览器及元素变化
    // resizeListener() {
    //   clearTimeout(this.resizeTimer);

    //   this.resizeTimer = setTimeout(() => {
    //     this.$nextTick(() => {
    //       this.clientWidth = document.documentElement.clientWidth;
    //       this.clientHeight = document.documentElement.clientHeight;

    //       this.topLeftChartInstance && this.topLeftChartInstance.resize();
    //       this.topRightChartInstance && this.topRightChartInstance.resize();
    //       this.middleLeftChartInstance && this.middleLeftChartInstance.resize();
    //       this.middleRightChartInstance &&
    //         this.middleRightChartInstance.resize();
    //       this.bottomLeftChartInstance && this.bottomLeftChartInstance.resize();
    //       this.bottomRightChartInstance &&
    //         this.bottomRightChartInstance.resize();
    //       this.mapChartInstance && this.mapChartInstance.resize();
    //     });
    //   }, 300);
    // },

    // 处理表格数据填充, 当没有表格数据条目数不足时自动不全
    handleInitTableData(arr) {
      if (arr.length < 6) {
        for (let i = arr.length; i < 6; i++) {
          arr.push({
            comparyNum: "",
            AreaName: "",
            freezerNum: "",
            storageNum: "",
            vehicleNum: ""
          });
        }
      }
      return arr;
    },

    // 实时查询企业、今日新增企业、冷藏车、冷库、冷柜个数
    queryNumberByRealTime() {
      FetchNumberByRealTime().then(res => {
        if (res.code == 1) {
          this.topTotalNumber.comparyNum = res.result.comparyNum;
          this.topTotalNumber.addComparyNum = res.result.addComparyNum;
          this.topTotalNumber.coldStorageVehicleNum =
            res.result.coldStorageVehicleNum;
          this.topTotalNumber.storageNum = res.result.storageNum;
          this.topTotalNumber.freezerNum = res.result.freezerNum;
        } else {
          this.$message({
            message: res.message,
            type: "error"
          });
        }
      });
    },

    // 实时查询各地区下企业、车辆、冷库、冷柜个数接口
    queryNumberByAreaName() {
      FetchNumberByAreaName().then(res => {
        // let tableData1 = [];
        // let tableData2 = [];
        if (res.code == 1) {
          this.tableObj = {};
          this.vehicleNumData = [];
          res.result.forEach(item => {
            if (item.vehicleNum != 0) {
              this.vehicleNumData.push({
                areaName: item.areaName,
                comparyNum: item.vehicleNum // 共用方法converData
              });
            }
          });
          // 如果要显示两张表格数据的话
          if (res.result.length > 6) {
            let len = Math.ceil(res.result.length / 6);

            for (let i = 0, j = 0; i < len; i++) {
              this.tableObj["table" + i] = res.result.slice(j, j + 6);
              this.tableObj["table" + i] = this.handleInitTableData(
                this.tableObj["table" + i]
              );
              j += 6;
            }

            // tableData1 = res.result.slice(0, 6);
            // tableData2 = res.result.slice(6);
            // this.tableData1 = this.handleInitTableData(tableData1);
            // this.tableData2 = this.handleInitTableData(tableData2);
          } else {
            this.tableObj["table1"] = res.result;
            this.tableObj["table1"] = this.handleInitTableData(
              this.tableObj["table1"]
            );

            // tableData1 = res.result;
            // this.tableData1 = this.handleInitTableData(tableData1);
          }
        } else {
          this.$message({
            message: res.message,
            type: "error"
          });
        }
      });
    },

    /************************** topLeft ************************************/
    // 获取企业、车、库、柜变化趋势数据
    fetchTopLeftChartData() {
      this.topLeftLoading = true;
      this.topLeftChartData = [];
      FetchCountNumMonth()
        .then(({ code, result, message }) => {
          if (code === 1 && Array.isArray(result)) {
            this.topLeftChartData = this.formatTopLeftChartData(result);
          } else {
            this.errorMessage(message || "获取企业/车/库/柜变化趋势数据失败");
          }
        })
        .catch(err => {
          console.log(err);
          this.errorMessage("获取企业/车/库/柜变化趋势数据失败");
        })
        .finally(() => {
          this.topLeftLoading = false;
          // this.initTopLeftChart();
        });
    },
    // 格式化获取企业、车、库、柜变化趋势数据，计算趋势
    formatTopLeftChartData(list) {
      const dataLength = list.length;
      let comparyNumMap = [];
      let freezerNumMap = [];
      let storageNumMap = [];
      let vehicleNumMap = [];

      for (let i = 0; i < dataLength; i++) {
        comparyNumMap.push([i, list[i].comparyNum || 0]);
        freezerNumMap.push([i, list[i].freezerNum || 0]);
        storageNumMap.push([i, list[i].storageNum || 0]);
        vehicleNumMap.push([i, list[i].vehicleNum || 0]);
      }

      const { points: comparyNumTrendData } = ECStat.regression(
        "linear",
        comparyNumMap
      );
      const { points: freezerNumTrendData } = ECStat.regression(
        "linear",
        freezerNumMap
      );
      const { points: storageNumTrendData } = ECStat.regression(
        "linear",
        storageNumMap
      );
      const { points: vehicleNumTrendData } = ECStat.regression(
        "linear",
        vehicleNumMap
      );

      for (let i = 0; i < dataLength; i++) {
        list[i].comparyNumTrend = comparyNumTrendData[i][1];
        list[i].freezerNumTrend = freezerNumTrendData[i][1];
        list[i].storageNumTrend = storageNumTrendData[i][1];
        list[i].vehicleNumTrend = vehicleNumTrendData[i][1];
      }

      return list;
    },
    // 初始化左上角图表
    initTopLeftChart() {
      if (this.topLeftChartInstance) {
        this.topLeftChartInstance.clear();
      } else {
        this.topLeftChartInstance = Echarts.init(this.$refs.topLeftChartDOM);
        this.topLeftChartInstance.on("timelinechanged", ({ currentIndex }) => {
          this.topLeftTimelineActiveIndex = currentIndex;
        });
      }
      const timelineData = this.topLeftTimelineData;
      const DATA_LENGTH = this.topLeftChartData.length;
      const options = [
        {
          dataset: {
            dimensions: ["countDate", "comparyNum", "comparyNumTrend"]
          },
          series: [
            {
              name: "企业",
              itemStyle: {
                color: item =>
                  this.calcGradualChangeColor(
                    item.dataIndex,
                    DATA_LENGTH,
                    [109, 173, 249],
                    [96, 165, 249]
                  )
              },
              lineStyle: {
                color: {
                  type: "linear",
                  x: 0,
                  y: 0,
                  x2: 1,
                  y2: 0,
                  colorStops: [
                    {
                      offset: 0,
                      color: "#4e9cfb" // 0% 处的颜色
                    },
                    {
                      offset: 1,
                      color: "#2f8bf9" // 100% 处的颜色
                    }
                  ],
                  global: false // 缺省为 false
                }
              },
              areaStyle: {
                color: {
                  type: "linear",
                  x: 0,
                  y: 0,
                  x2: 0,
                  y2: 1,
                  colorStops: [
                    {
                      offset: 0,
                      color: "#c5ddf9" // 0% 处的颜色
                    },
                    {
                      offset: 1,
                      color: "#d9e8fb" // 100% 处的颜色
                    }
                  ],
                  global: false // 缺省为 false
                }
              }
            },
            {
              name: "企业趋势",
              lineStyle: {
                color: {
                  type: "linear",
                  x: 0,
                  y: 0,
                  x2: 1,
                  y2: 0,
                  colorStops: [
                    {
                      offset: 0,
                      color: "#65a8f8" // 0% 处的颜色
                    },
                    {
                      offset: 1,
                      color: "#65a8f8" // 100% 处的颜色
                    }
                  ],
                  global: false // 缺省为 false
                }
              }
            }
          ]
        },
        {
          dataset: {
            dimensions: ["countDate", "storageNum", "storageNumTrend"]
          },
          series: [
            {
              name: "冷库",
              itemStyle: {
                color: item =>
                  this.calcGradualChangeColor(
                    item.dataIndex,
                    DATA_LENGTH,
                    [59, 233, 203], // 点的渐变
                    [20, 184, 117]
                  )
              },
              lineStyle: {
                color: {
                  type: "linear",
                  x: 0,
                  y: 0,
                  x2: 1,
                  y2: 0,
                  colorStops: [
                    //线的渐变
                    {
                      offset: 0,
                      color: "#3be9cb" // 0% 处的颜色
                    },
                    {
                      offset: 1,
                      color: "#14b875" // 100% 处的颜色
                    }
                  ],
                  global: false // 缺省为 false
                }
              },
              areaStyle: {
                // 区域实现线性渐变
                color: {
                  type: "linear",
                  x: 0,
                  y: 0,
                  x2: 0,
                  y2: 1,
                  colorStops: [
                    {
                      offset: 0,
                      color: "#d9f1e4" // 0% 处的颜色
                    },
                    {
                      offset: 1,
                      color: "#def3e8" // 100% 处的颜色
                    }
                  ],
                  global: false // 缺省为 false
                }
              }
            },
            {
              name: "冷库趋势",
              lineStyle: {
                color: {
                  type: "linear",
                  x: 0,
                  y: 0,
                  x2: 1,
                  y2: 0,
                  colorStops: [
                    {
                      offset: 0,
                      color: "#59c699" // 0% 处的颜色
                    },
                    {
                      offset: 1,
                      color: "#3dc48d" // 100% 处的颜色
                    }
                  ],
                  global: false // 缺省为 false
                }
              }
            }
          ]
        },
        {
          dataset: {
            dimensions: ["countDate", "freezerNum", "freezerNumTrend"]
          },
          series: [
            {
              name: "冷柜",
              itemStyle: {
                color: item =>
                  this.calcGradualChangeColor(
                    item.dataIndex,
                    DATA_LENGTH,
                    [235, 134, 82],
                    [235, 134, 82]
                  )
              },
              lineStyle: {
                color: {
                  type: "linear",
                  x: 0,
                  y: 0,
                  x2: 1,
                  y2: 0,
                  colorStops: [
                    {
                      offset: 0,
                      color: "#ebc258" // 0% 处的颜色
                    },
                    {
                      offset: 1,
                      color: "#c6762f" // 100% 处的颜色
                    }
                  ],
                  global: false // 缺省为 false
                }
              },
              areaStyle: {
                // 区域实现线性渐变
                color: {
                  type: "linear",
                  x: 0,
                  y: 0,
                  x2: 0,
                  y2: 1,
                  colorStops: [
                    {
                      offset: 0,
                      color: "#fdf0e8" // 0% 处的颜色
                    },
                    {
                      offset: 1,
                      color: "#fdf9ed" // 100% 处的颜色
                    }
                  ],
                  global: false // 缺省为 false
                }
              }
            },
            {
              name: "冷柜趋势",
              lineStyle: {
                color: {
                  type: "linear",
                  x: 0,
                  y: 0,
                  x2: 1,
                  y2: 0,
                  colorStops: [
                    {
                      offset: 0,
                      color: "#ebd58d" // 0% 处的颜色
                    },
                    {
                      offset: 1,
                      color: "#dc9e74" // 100% 处的颜色
                    }
                  ],
                  global: false // 缺省为 false
                }
              }
            }
          ]
        },
        {
          dataset: {
            dimensions: ["countDate", "vehicleNum", "vehicleNumTrend"]
          },
          series: [
            {
              name: "车",
              itemStyle: {
                color: item =>
                  this.calcGradualChangeColor(
                    item.dataIndex,
                    DATA_LENGTH,
                    [175, 163, 245],
                    [105, 85, 255]
                  )
              },
              lineStyle: {
                color: {
                  type: "linear",
                  x: 0,
                  y: 0,
                  x2: 1,
                  y2: 0,
                  colorStops: [
                    {
                      offset: 0,
                      color: "#c9c2ff" // 0% 处的颜色
                    },
                    {
                      offset: 1,
                      color: "#907dfb" // 100% 处的颜色
                    }
                  ],
                  global: false // 缺省为 false
                }
              },
              areaStyle: {
                // 区域实现线性渐变
                color: {
                  type: "linear",
                  x: 0,
                  y: 0,
                  x2: 0,
                  y2: 1,
                  colorStops: [
                    {
                      offset: 0,
                      color: "#ddd9ff" // 0% 处的颜色
                    },
                    {
                      offset: 1,
                      color: "#e0dcff" // 100% 处的颜色
                    }
                  ],
                  global: false // 缺省为 false
                }
              },
              data: this.topLeftChartData.seriesVehicleData
            },
            {
              name: "车趋势",
              lineStyle: {
                color: {
                  type: "linear",
                  x: 0,
                  y: 0,
                  x2: 1,
                  y2: 0,
                  colorStops: [
                    {
                      offset: 0,
                      color: "#c9c2ff" // 0% 处的颜色
                    },
                    {
                      offset: 1,
                      color: "#907dfb" // 100% 处的颜色
                    }
                  ],
                  global: false // 缺省为 false
                }
              }
            }
          ]
        }
      ];

      this.topLeftChartInstance.setOption({
        baseOption: {
          title: {
            text: "企业/车/库/柜变化趋势",
            textStyle: {
              color: "#727274",
              fontFamily: "Courier New",
              fontSize: this.calcXDirectionSizeByPercent(14),
              lineHeight: this.calcYDirectionSizeByPercent(30)
            },
            padding: [
              this.calcYDirectionSizeByPercent(2),
              this.calcXDirectionSizeByPercent(0),
              0,
              this.calcXDirectionSizeByPercent(10)
            ]
          },
          tooltip: {
            trigger: "axis",
            axisPointer: {
              type: "line",
              label: {
                backgroundColor: "#6a7985"
              }
            },
            formatter: item => {
              const itemInfo = item[0];
              return `<div>${itemInfo.axisValue}</div>
                     <span style="
                        display:inline-block;
                        margin-right:5px;
                        margin-bottom:2px;
                        border-radius:10px;
                        width:9px;
                        height:9px;
                        background-color: ${itemInfo.color}">
                     </span>
                     ${itemInfo.seriesName}: ${
                itemInfo.data[itemInfo.dimensionNames[1]]
              }`;
            }
          },
          grid: {
            bottom: this.calcYDirectionSizeByPercent(30),
            right: this.calcXDirectionSizeByPercent(21),
            top: this.calcYDirectionSizeByPercent(54),
            left: this.calcXDirectionSizeByPercent(50)
          },
          dataset: {
            source: this.topLeftChartData
          },
          timeline: {
            show: false,
            autoPlay: true,
            loop: true,
            axisType: "category",
            playInterval: 1e3 * 4,
            data: timelineData
          },
          xAxis: {
            type: "category",
            boundaryGap: false,
            axisTick: {
              // 坐标刻度
              show: false
            },
            axisLine: {
              // 坐标轴线
              show: true,
              lineStyle: {
                color: "#d9d4ce"
              }
            },
            axisLabel: {
              interval: 2,
              color: "#666",
              fontSize: this.calcXDirectionSizeByPercent(11)
            }
          },
          yAxis: {
            type: "value",
            min: 0,
            axisTick: {
              show: false
            },
            axisLine: {
              // 坐标轴线
              show: true,
              lineStyle: {
                color: "#d9d4ce"
              }
            },
            splitLine: {
              show: false
            },
            axisLabel: {
              color: "#666",
              fontSize: this.calcXDirectionSizeByPercent(11)
            }
          },
          series: [
            {
              type: "line",
              smooth: true,
              symbol: "circle", // 实心图例
              symbolSize: this.calcXDirectionSizeByPercent(6) // 图例大小
            },
            {
              type: "line",
              smooth: true,
              symbolSize: 0,
              itemStyle: {
                opacity: 0
              },
              lineStyle: {
                type: "dashed"
              }
            }
          ]
        },
        options
      });

      // 自动聚焦轮播
      let currentHighlightIndex = 0;
      clearInterval(this.topLeftAutoHighlightTimer);
      this.topLeftAutoHighlightTimer = setInterval(() => {
        this.topLeftChartInstance.dispatchAction({
          type: "showTip",
          seriesIndex: 0,
          dataIndex: currentHighlightIndex++
        });

        if (currentHighlightIndex === DATA_LENGTH) {
          currentHighlightIndex = 0;
        }
      }, 1e3 * 2);
    },
    // 左上角图表进度更改
    topLeftChartTimelineProgressChange(index) {
      this.topLeftTimelineActiveIndex = index;
      this.topLeftChartInstance.dispatchAction({
        type: "timelineChange",
        currentIndex: index
      });
    },

    /************************** topRight ************************************/
    // 获取综合在线率数据
    fetchTopRightData() {
      this.topRightLoading = true;
      this.topRightChartData = [];
      FetchOnlineAndQualifyRateByDay()
        .then(({ code, result, message }) => {
          if (code === 1 && Array.isArray(result)) {
            this.topRightChartData = this.formatTopRightChartData(result);
          } else {
            this.errorMessage(
              message || "获取综合在线率及温度合格率变化趋势失败"
            );
          }
        })
        .catch(err => {
          console.log(err);
          this.errorMessage("获取综合在线率及温度合格率变化趋势失败");
        })
        .finally(() => {
          this.topRightLoading = false;
          this.initTopRightChart();
        });
    },
    // 格式化综合在线率数据，计算趋势
    formatTopRightChartData(list) {
      const dataLength = list.length;
      let onlineRateMap = [];
      let qualifyRateMap = [];

      for (let i = 0; i < dataLength; i++) {
        onlineRateMap.push([i, list[i].onlineRate || 0]);
        qualifyRateMap.push([i, list[i].qualifyRate || 0]);
      }

      const { points: onlineRateTrendData } = ECStat.regression(
        "linear",
        onlineRateMap
      );
      const { points: qualifyRateTrendData } = ECStat.regression(
        "linear",
        qualifyRateMap
      );

      for (let i = 0; i < dataLength; i++) {
        list[i].onlineRateTrend = onlineRateTrendData[i][1];
        list[i].qualifyRateTrend = qualifyRateTrendData[i][1];
      }

      return list;
    },
    // 初始化右上角图表
    initTopRightChart() {
      if (this.topRightChartInstance) {
        this.topRightChartInstance.clear();
      } else {
        this.topRightChartInstance = Echarts.init(this.$refs.topRightChartDOM);
        this.topRightChartInstance.on("timelinechanged", ({ currentIndex }) => {
          this.topRightTimelineActiveIndex = currentIndex;
        });
      }
      const timelineData = ["在线率", "温度合格率"];
      const DATA_LENGTH = this.topRightChartData.length;
      const options = [
        {
          dataset: {
            dimensions: ["monitorDay", "onlineRate", "onlineRateTrend"]
          },
          series: [
            {
              name: "在线率",
              itemStyle: {
                color: item =>
                  this.calcGradualChangeColor(
                    item.dataIndex,
                    DATA_LENGTH,
                    [1, 138, 255],
                    [67, 72, 255]
                  )
              },
              lineStyle: {
                color: {
                  type: "linear",
                  x: 0,
                  y: 0,
                  x2: 1,
                  y2: 0,
                  colorStops: [
                    {
                      offset: 0,
                      color: "#0087ff" // 0% 处的颜色
                    },
                    {
                      offset: 1,
                      color: "#464cea" // 100% 处的颜色
                    }
                  ],
                  global: false // 缺省为 false
                }
              },
              areaStyle: {
                color: {
                  type: "linear",
                  x: 0,
                  y: 0,
                  x2: 0,
                  y2: 1,
                  colorStops: [
                    {
                      offset: 0,
                      color: "#e3f5ff" // 0% 处的颜色
                    },
                    {
                      offset: 1,
                      color: "#eeedff" // 100% 处的颜色
                    }
                  ],
                  global: false // 缺省为 false
                }
              }
            },
            {
              name: "在线率趋势",
              lineStyle: {
                color: {
                  type: "linear",
                  x: 0,
                  y: 0,
                  x2: 1,
                  y2: 0,
                  colorStops: [
                    {
                      offset: 0,
                      color: "#0089ff" // 0% 处的颜色
                    },
                    {
                      offset: 1,
                      color: "#4044fd" // 100% 处的颜色
                    }
                  ],
                  global: false // 缺省为 false
                }
              }
            }
          ]
        },
        {
          dataset: {
            dimensions: ["monitorDay", "qualifyRate", "qualifyRateTrend"]
          },
          series: [
            {
              name: "温度合格率",
              itemStyle: {
                color: item =>
                  this.calcGradualChangeColor(
                    item.dataIndex,
                    DATA_LENGTH,
                    [63, 238, 212],
                    [1, 161, 76]
                  )
              },
              lineStyle: {
                color: {
                  type: "linear",
                  x: 0,
                  y: 0,
                  x2: 1,
                  y2: 0,
                  colorStops: [
                    {
                      offset: 0,
                      color: "#28d2a2" // 0% 处的颜色
                    },
                    {
                      offset: 1,
                      color: "#00a24c" // 100% 处的颜色
                    }
                  ],
                  global: false // 缺省为 false
                }
              },
              areaStyle: {
                color: {
                  type: "linear",
                  x: 0,
                  y: 0,
                  x2: 0,
                  y2: 1,
                  colorStops: [
                    {
                      offset: 0,
                      color: "#e3f4eb" // 0% 处的颜色
                    },
                    {
                      offset: 1,
                      color: "#e6f6ee" // 100% 处的颜色
                    }
                  ],
                  global: false // 缺省为 false
                }
              }
            },
            {
              name: "温度合格率趋势",
              lineStyle: {
                color: {
                  type: "linear",
                  x: 0,
                  y: 0,
                  x2: 1,
                  y2: 0,
                  colorStops: [
                    {
                      offset: 0,
                      color: "#28d2a2" // 0% 处的颜色
                    },
                    {
                      offset: 1,
                      color: "#00a24c" // 100% 处的颜色
                    }
                  ],
                  global: false // 缺省为 false
                }
              }
            }
          ]
        }
      ];

      this.topRightChartInstance.setOption({
        baseOption: {
          title: {
            text: "综合在线率及温度合格率变化趋势",
            textStyle: {
              color: "#727274",
              fontFamily: "Courier New",
              fontSize: this.calcXDirectionSizeByPercent(14),
              lineHeight: this.calcYDirectionSizeByPercent(30)
            },
            padding: [
              this.calcYDirectionSizeByPercent(2),
              0,
              0,
              this.calcXDirectionSizeByPercent(10)
            ]
          },
          tooltip: {
            trigger: "axis",
            axisPointer: {
              type: "line",
              label: {
                backgroundColor: "#6a7985"
              }
            },
            formatter: item => {
              const itemInfo = item[0];
              return `<div>${itemInfo.axisValue}</div>
                     <span style="
                        display:inline-block;
                        margin-right:5px;
                        margin-bottom:2px;
                        border-radius:10px;
                        width:9px;
                        height:9px;
                        background-color: ${itemInfo.color}">
                     </span>
                     ${itemInfo.seriesName}: ${
                itemInfo.data[itemInfo.dimensionNames[1]]
              }`;
            }
          },
          timeline: {
            show: false,
            autoPlay: true,
            loop: true,
            axisType: "category",
            playInterval: 1e3 * 4,
            data: timelineData
          },
          grid: {
            bottom: this.calcYDirectionSizeByPercent(30),
            right: this.calcXDirectionSizeByPercent(24),
            top: this.calcYDirectionSizeByPercent(55),
            left: this.calcXDirectionSizeByPercent(38)
          },
          dataset: {
            source: this.topRightChartData
          },
          xAxis: {
            type: "category",
            boundaryGap: false,
            axisTick: {
              // 坐标刻度
              show: false
            },
            axisLine: {
              // 坐标轴线
              lineStyle: {
                color: "#e1e6ec"
              }
            },
            axisLabel: {
              interval: 2,
              color: "#666"
            }
          },
          yAxis: {
            type: "value",
            min: 0,
            axisTick: {
              show: false
            },
            axisLabel: {
              color: "#666"
            },
            axisLine: {
              // 坐标轴
              lineStyle: {
                color: "#e1e6ec"
              }
            },
            splitLine: {
              // 分割线
              show: false
            }
          },
          series: [
            {
              type: "line",
              smooth: true, // 平滑折现
              symbol: "circle", // 实心图例
              symbolSize: 6 // 图例大小
            },
            {
              type: "line",
              smooth: true,
              symbolSize: 0,
              itemStyle: {
                opacity: 0
              },
              lineStyle: {
                type: "dashed",
                width: 1
              }
            }
          ]
        },
        options
      });

      // 自动聚焦轮播
      let currentHighlightIndex = 0;
      clearInterval(this.topRightAutoHighlightTimer);
      this.topRightAutoHighlightTimer = setInterval(() => {
        this.topRightChartInstance.dispatchAction({
          type: "showTip",
          seriesIndex: 0,
          dataIndex: currentHighlightIndex++
        });

        if (currentHighlightIndex === DATA_LENGTH) {
          currentHighlightIndex = 0;
        }
      }, 1e3 * 2);
    },
    // 右上角图表进度更改
    topRightChartTimelineProgressChange(index) {
      this.topRightTimelineActiveIndex = index;
      this.topRightChartInstance.dispatchAction({
        type: "timelineChange",
        currentIndex: index
      });
    },

    /************************** MiddleLeft ************************************/
    // 获取不同行业企业数及占比数据
    fetchMiddleLeftChartData() {
      clearInterval(this.middleLeftFetchDataTimer);
      const fetchDataFun = () => {
        this.middleLeftLoading = true;
        FetchCompanyNumAndRate()
          .then(({ code, result, message }) => {
            if (code === 1 && Array.isArray(result)) {
              this.middleLeftChartData = result;
            } else {
              this.errorMessage(message || "获取不同行业企业数及占比数据失败");
            }
          })
          .catch(err => {
            console.log(err);
            this.errorMessage("获取不同行业企业数及占比数据失败");
          })
          .finally(() => {
            this.middleLeftLoading = false;
            // this.initMiddleLeftChart();
          });
      };
      fetchDataFun();
      this.middleLeftFetchDataTimer = setInterval(
        fetchDataFun,
        this.reloadDataTime
      );
    },
    // 初始化中部左侧图表
    initMiddleLeftChart() {
      if (this.middleLeftChartInstance) {
        this.middleLeftChartInstance.clear();
      } else {
        this.middleLeftChartInstance = Echarts.init(
          this.$refs.middleLeftChartDOM
        );
      }

      const option = {
        color: ["#015098", "#00ace8", "#ff7800", "#fd2a81", "#6baf01"],
        title: {
          text: "不同行业企业数及占比",
          textStyle: {
            color: "#727274",
            fontFamily: "Courier New",
            fontSize: this.calcXDirectionSizeByPercent(14),
            lineHeight: this.calcYDirectionSizeByPercent(30)
          },
          padding: [0, 0, 0, this.calcXDirectionSizeByPercent(10)]
        },
        dataset: {
          dimensions: ["comparyNum", "comparyNum"],
          source: this.middleLeftChartData
        },
        series: [
          {
            name: "背景",
            type: "pie",
            center: ["50%", "60%"],
            radius: ["24%", "56%"],
            label: { show: false },
            hoverOffset: 0,
            labelLine: { show: false }
          },
          {
            name: "图",
            type: "pie",
            center: ["50%", "60%"],
            radius: ["24%", "56%"],
            label: {
              formatter: ({ data }) =>
                `{style1|${data.managerModelName || ""}}\n{style2|${
                  data.comparyNum
                }} {style3|(${data.comparyRate})}`,
              rich: {
                style1: {
                  fontSize: this.calcXDirectionSizeByPercent(12),
                  lineHeight: this.calcXDirectionSizeByPercent(16),
                  color: "#676767"
                },
                style2: {
                  fontSize: this.calcXDirectionSizeByPercent(14),
                  lineHeight: this.calcXDirectionSizeByPercent(18),
                  color: "#5d5d5d"
                },
                style3: {
                  fontSize: this.calcXDirectionSizeByPercent(12),
                  lineHeight: this.calcXDirectionSizeByPercent(16),
                  color: "#5f5f5f"
                }
              }
            }
          }
        ]
      };

      this.middleLeftChartInstance.setOption(option);
    },

    /************************** MiddleRight ************************************/
    // 获取各地区冷藏车辆在线率
    fetchMiddleRightChartsData() {
      this.middleRightLoading = true;
      FetchVehicleOrStorageOnline({ scene: 3 })
        .then(({ code, result, message }) => {
          if (code === 1 && result) {
            this.middleRightChartData = result;
          } else {
            this.errorMessage(message || "获取各地区车辆在线率数据失败");
          }
        })
        .catch(err => {
          console.log(err);
          this.errorMessage("获取各地区车辆在线率数据失败");
        })
        .finally(() => {
          this.middleRightLoading = true;
          this.initMiddleRightChart();
        });
    },
    // 初始化底部右侧图表
    initMiddleRightChart() {
      if (this.middleRightChartInstance) {
        this.middleRightChartInstance.clear();
      } else {
        this.middleRightChartInstance = Echarts.init(
          this.$refs.middleRightChartDOM
        );
      }

      // 数据重新处理，将数据为0的项统一放至最后
      let saveOnlineQualifyArrayObj = [];
      let getChartData = this.middleRightChartData;
      for (let i = 0, len = getChartData.areaNameList.length; i < len; i++) {
        saveOnlineQualifyArrayObj.push({
          name: getChartData.areaNameList[i],
          online: getChartData.onlineRateList[i],
          all: Number(getChartData.onlineRateList[i])
        });
      }
      function sortBy(props) {
        return function(a, b) {
          return b[props] - a[props];
        };
      }
      saveOnlineQualifyArrayObj.sort(sortBy("all"));

      const xAxisData = saveOnlineQualifyArrayObj.map(v => v.name);
      const seriesOnlineRateData = saveOnlineQualifyArrayObj.map(v => v.online);

      const option = {
        title: {
          text: "广东省各地区车辆在线率",
          textStyle: {
            color: "#727274",
            fontFamily: "Courier New",
            fontSize: this.calcXDirectionSizeByPercent(14),
            lineHeight: this.calcYDirectionSizeByPercent(30)
          },
          padding: [2, 0, 0, 10]
        },
        legend: {
          top: this.calcYDirectionSizeByPercent(12),
          right: this.calcXDirectionSizeByPercent(17),
          itemWidth: this.calcXDirectionSizeByPercent(15),
          itemHeight: this.calcYDirectionSizeByPercent(8),
          fontSize: this.calcXDirectionSizeByPercent(12),
          textStyle: {
            color: "#7a7a7a"
          },
          data: ["在线率"]
        },
        tooltip: {
          trigger: "axis",
          axisPointer: {
            type: "shadow",
            label: {
              backgroundColor: "#6a7985"
            }
          },
          formatter: function(params) {
            let result = "<div>" + params[0].axisValue + "在线率</div>";
            params.forEach((item, index) => {
              result +=
                '<span style="display:inline-block;margin-right:5px;margin-bottom:2px;border-radius:10px;width:9px;height:9px;background-color:' +
                item.color.colorStops[index].color +
                '"></span>';
              result += `${item.seriesName}: ${item.value}%<br />`;
            });
            return result;
          }
        },
        grid: {
          top: this.calcYDirectionSizeByPercent(56),
          left: this.calcXDirectionSizeByPercent(35),
          right: this.calcXDirectionSizeByPercent(14),
          bottom: this.calcYDirectionSizeByPercent(50)
        },
        xAxis: {
          type: "category",
          axisTick: {
            show: false
          },
          axisLine: {
            lineStyle: {
              color: "#e1e6ec"
            }
          },
          axisLabel: {
            color: "#666",
            fontSize: this.calcXDirectionSizeByPercent(12),
            formatter: function(value) {
              // 管城回族区长度超出范围格式化
              if (value.length > 3) {
                return `${value.slice(0, 3)}\n${value.slice(3)}`;
              } else {
                return value;
              }
            }
          },
          data: xAxisData
        },
        yAxis: {
          type: "value",
          axisTick: {
            show: false
          },
          splitLine: {
            show: true
          },
          axisLabel: {
            color: "#666"
          },
          axisLine: {
            lineStyle: {
              color: "#e1e6ec"
            }
          }
        },
        series: [
          {
            type: "bar",
            name: "在线率",
            barMaxWidth: this.calcYDirectionSizeByPercent(15),
            itemStyle: {
              color: {
                type: "linear",
                x: 0,
                y: 0,
                x2: 0,
                y2: 1,
                colorStops: [
                  {
                    offset: 0,
                    color: "#4cae37" // 0% 处的颜色
                  },
                  {
                    offset: 1,
                    color: "#4cae37" // 100% 处的颜色
                  }
                ],
                globalCoord: false // 缺省为 false
              }
              // barBorderRadius: [15, 15, 0, 0]
            },
            data: seriesOnlineRateData
          }
        ]
      };

      this.middleRightChartInstance.setOption(option);

      clearInterval(this.middleRightAutoHighlightTimer);
      let currentHighlightIndex = 0;
      this.middleRightAutoHighlightTimer = setInterval(() => {
        this.middleRightChartInstance.dispatchAction({
          type: "showTip",
          seriesIndex: 0,
          dataIndex: currentHighlightIndex++
        });

        if (currentHighlightIndex === xAxisData.length) {
          currentHighlightIndex = 0;
        }
      }, 1e3 * 4);
    },

    /************************** bottomLeft ************************************/
    // 获取各地区企业数排行及占比数据
    fetchBottomLeftData() {
      clearInterval(this.bottomLeftFetchDataTimer);
      const fetchDataFun = () => {
        this.bottomLeftLoading = true;
        FetchCompanyNumAndRateByAreaName()
          .then(({ code, message, result }) => {
            if (code === 1 && Array.isArray(result)) {
              this.bottomLeftChartData = result.slice(0, 12);
            } else {
              this.errorMessage(
                message || "获取各地区企业数排行及占比数据失败"
              );
            }
          })
          .catch(err => {
            console.log(err);
            this.errorMessage("获取各地区企业数排行及占比数据失败");
          })
          .finally(() => {
            this.bottomLeftLoading = false;
            this.fetchCenterMapData();
            // this.initBottomLeftChart();
          });
      };
      fetchDataFun();
      this.bottomLeftFetchDataTimer = setInterval(
        fetchDataFun,
        this.reloadDataTime
      );
    },
    // 初始化底部左侧图表
    initBottomLeftChart() {
      if (this.bottomLeftChartInstance) {
        this.bottomLeftChartInstance.clear();
      } else {
        this.bottomLeftChartInstance = Echarts.init(
          this.$refs.bottomLeftChartDOM
        );
      }

      const option = {
        title: {
          text: "各地区企业数排行及占比",
          textStyle: {
            color: "#727274",
            fontFamily: "Courier New",
            fontSize: this.calcXDirectionSizeByPercent(14),
            lineHeight: this.calcYDirectionSizeByPercent(30)
          },
          padding: [
            this.calcYDirectionSizeByPercent(2),
            0,
            0,
            this.calcXDirectionSizeByPercent(10)
          ]
        },
        tooltip: {
          trigger: "axis",
          axisPointer: {
            type: "shadow",
            label: {
              fontSize: this.calcXDirectionSizeByPercent(14)
            }
          },
          formatter: function(params) {
            let result =
              "<div>" + params[0].axisValue + "企业数排行及占比</div>";
            result +=
              '<span style="display:inline-block;margin-right:5px;margin-bottom:2px;border-radius:10px;width:9px;height:9px;background-color:' +
              params[0].color.colorStops[0].color +
              '"></span>';
            result += `企业数量：${params[0].value.comparyNum}<br />`;
            result +=
              '<span style="display:inline-block;margin-right:5px;margin-bottom:2px;border-radius:10px;width:9px;height:9px;background-color:' +
              params[0].color.colorStops[1].color +
              '"></span>';
            result += `企业数占比: ${params[0].value.comparyRate}%<br />`;
            return result;
          }
        },
        grid: {
          top: this.calcYDirectionSizeByPercent(80),
          left: this.calcXDirectionSizeByPercent(25),
          right: this.calcXDirectionSizeByPercent(20),
          bottom: this.calcYDirectionSizeByPercent(47)
        },
        dataset: {
          dimensions: [
            "areaName",
            "comparyNum",
            "comparyRate",
            "comparyTotalNum"
          ],
          source: this.bottomLeftChartData
        },
        xAxis: {
          type: "category",
          axisLine: {
            show: false
          },
          axisTick: {
            show: false
          },
          axisLabel: {
            color: "#6e6e6e",
            fontSize: 12,
            formatter: function(value) {
              // 管城回族区长度超出范围格式化
              if (value.length > 3) {
                return `${value.slice(0, 3)}\n${value.slice(3)}`;
              } else {
                return value;
              }
            }
          }
        },
        yAxis: {
          type: "value",
          axisLine: {
            show: false
          },
          axisTick: {
            show: false
          },
          axisLabel: {
            show: false
          },
          splitLine: {
            show: false
          }
        },
        series: [
          {
            type: "bar",
            barMaxWidth: this.calcXDirectionSizeByPercent(15),
            label: {
              show: true,
              position: "top",
              formatter: function({ value }) {
                return `{totalNum|${value.comparyNum}}\n{rate|${value.comparyRate}%}`;
              },
              rich: {
                totalNum: {
                  fontSize: 14,
                  color: "#414141",
                  align: "center"
                },
                rate: {
                  fontSize: 10,
                  color: "#414141",
                  align: "center"
                }
              }
            },
            itemStyle: {
              color: {
                type: "linear",
                x: 0,
                y: 0,
                x2: 0,
                y2: 1,
                colorStops: [
                  {
                    offset: 0,
                    color: "#ff583d" // 0% 处的颜色
                  },
                  {
                    offset: 1,
                    color: "#e73c21" // 100% 处的颜色
                  }
                ],
                globalCoord: false // 缺省为 false
              },
              barBorderRadius: 15
            }
          }
        ]
      };

      this.bottomLeftChartInstance.setOption(option);

      clearInterval(this.bottomLeftAutoHighlightTimer);
      let currentHighlightIndex = 0;
      const DATA_LENGTH = this.bottomLeftChartData.length;
      this.bottomLeftAutoHighlightTimer = setInterval(() => {
        this.bottomLeftChartInstance.dispatchAction({
          type: "showTip",
          seriesIndex: 0,
          dataIndex: currentHighlightIndex++
        });

        if (currentHighlightIndex === DATA_LENGTH) {
          currentHighlightIndex = 0;
        }
      }, 1e3 * 4);
    },

    /************************** bottomRight ************************************/
    // 获取各地区冷库在线率
    fetchBottomRightData() {
      this.bottomRightLoading = true;
      FetchVehicleOrStorageOnline({ scene: 1 })
        .then(({ code, result, message }) => {
          if (code === 1 && result) {
            this.bottomRightChartData = result;
          } else {
            this.errorMessage(message || "获取各地区冷库在线率数据失败");
          }
        })
        .catch(err => {
          console.log(err);
          this.errorMessage("获取各地区冷库在线率数据失败");
        })
        .finally(() => {
          this.bottomRightLoading = true;
          this.initBottomRightChart();
        });
    },
    // 初始化底部右侧图表
    initBottomRightChart() {
      if (this.bottomRightChartInstance) {
        this.bottomRightChartInstance.clear();
      } else {
        this.bottomRightChartInstance = Echarts.init(
          this.$refs.bottomRightChartDOM
        );
      }

      // 数据重新处理，将数据为0的项统一放至最后
      let saveOnlineQualifyArrayObj = [];
      let getChartData = this.bottomRightChartData;
      for (let i = 0, len = getChartData.areaNameList.length; i < len; i++) {
        saveOnlineQualifyArrayObj.push({
          name: getChartData.areaNameList[i],
          online: getChartData.onlineRateList[i],
          qualify: getChartData.qualifyRateList[i],
          all: Number(getChartData.onlineRateList[i])
        });
      }
      function sortBy(props) {
        return function(a, b) {
          return b[props] - a[props];
        };
      }
      saveOnlineQualifyArrayObj.sort(sortBy("all"));

      const xAxisData = saveOnlineQualifyArrayObj.map(v => v.name);
      const seriesOnlineRateData = saveOnlineQualifyArrayObj.map(v => v.online);

      const option = {
        title: {
          text: "广东省各地区冷库在线率",
          textStyle: {
            color: "#727274",
            fontFamily: "Courier New",
            fontSize: this.calcXDirectionSizeByPercent(14),
            lineHeight: this.calcYDirectionSizeByPercent(30)
          },
          padding: [2, 0, 0, 10]
        },
        legend: {
          top: this.calcYDirectionSizeByPercent(12),
          right: this.calcXDirectionSizeByPercent(17),
          itemWidth: this.calcXDirectionSizeByPercent(15),
          itemHeight: this.calcYDirectionSizeByPercent(8),
          fontSize: this.calcXDirectionSizeByPercent(12),
          textStyle: {
            color: "#7a7a7a"
          },
          data: ["在线率"]
        },
        tooltip: {
          trigger: "axis",
          axisPointer: {
            type: "shadow",
            label: {
              backgroundColor: "#6a7985"
            }
          },
          formatter: function(params) {
            let result = "<div>" + params[0].axisValue + "在线率</div>";
            params.forEach((item, index) => {
              result +=
                '<span style="display:inline-block;margin-right:5px;margin-bottom:2px;border-radius:10px;width:9px;height:9px;background-color:' +
                item.color.colorStops[index].color +
                '"></span>';
              result += `${item.seriesName}: ${item.value}%<br />`;
            });
            return result;
          }
        },
        grid: {
          top: this.calcYDirectionSizeByPercent(56),
          left: this.calcXDirectionSizeByPercent(35),
          right: this.calcXDirectionSizeByPercent(14),
          bottom: this.calcYDirectionSizeByPercent(50)
        },
        xAxis: {
          type: "category",
          axisTick: {
            show: false
          },
          axisLine: {
            lineStyle: {
              color: "#e1e6ec"
            }
          },
          axisLabel: {
            color: "#666",
            fontSize: this.calcXDirectionSizeByPercent(12),
            formatter: function(value) {
              // 管城回族区长度超出范围格式化
              if (value.length > 3) {
                return `${value.slice(0, 3)}\n${value.slice(3)}`;
              } else {
                return value;
              }
            }
          },
          data: xAxisData
        },
        yAxis: {
          type: "value",
          axisTick: {
            show: false
          },
          splitLine: {
            show: true
          },
          axisLabel: {
            color: "#666"
          },
          axisLine: {
            lineStyle: {
              color: "#e1e6ec"
            }
          }
        },
        series: [
          {
            type: "bar",
            name: "在线率",
            barMaxWidth: this.calcYDirectionSizeByPercent(15),
            itemStyle: {
              color: {
                type: "linear",
                x: 0,
                y: 0,
                x2: 0,
                y2: 1,
                colorStops: [
                  {
                    offset: 0,
                    color: "#2a166f" // 0% 处的颜色
                  },
                  {
                    offset: 1,
                    color: "#2a166f" // 100% 处的颜色
                  }
                ],
                globalCoord: false // 缺省为 false
              }
              // barBorderRadius: [15, 15, 0, 0]
            },
            data: seriesOnlineRateData
          }
        ]
      };

      this.bottomRightChartInstance.setOption(option);

      clearInterval(this.bottomRightAutoHighlightTimer);
      let currentHighlightIndex = 0;
      this.bottomRightAutoHighlightTimer = setInterval(() => {
        this.bottomRightChartInstance.dispatchAction({
          type: "showTip",
          seriesIndex: 0,
          dataIndex: currentHighlightIndex++
        });

        if (currentHighlightIndex === xAxisData.length) {
          currentHighlightIndex = 0;
        }
      }, 1e3 * 4);
    },

    /************************** centerMap ************************************/
    // 初始化中间地图geo数据，获取业务数据
    async initCenterMap() {
      // 获取地区内部/外部轮廓地理位置信息
      let geoDirName = this.$GLOBAL_CONFIG.home.map.geoDirName; // geo文件件
      let geoPromises = [
        import(`@/assets/geo/${geoDirName}/inline.json`),
        import(`@/assets/geo/${geoDirName}/outline.json`),
        import(`@/assets/geo/${geoDirName}/guangzhou/outline.json`)
      ];
      let [inlineGeo, outlineGeo, guangdongOutlineGeo] = await Promise.all(
        geoPromises
      );

      // 初始化地图
      this.mapOutlineGeo = Object.freeze(outlineGeo);
      this.mapGuangdongOutlineGeo = Object.freeze(guangdongOutlineGeo);
      Echarts.registerMap("inlineMap", inlineGeo);
      Echarts.registerMap("outlineMap", outlineGeo);
      // 获取地图业务数据
      this.fetchTopLeftChartData();
      this.fetchTopRightData();
      this.fetchMiddleLeftChartData();
      this.fetchBottomRightData();
      this.fetchMiddleRightChartsData();
      this.fetchBottomLeftData();
      this.queryNumberByRealTime();
      this.queryNumberByAreaName();
    },
    // 获取中部地图数据
    fetchCenterMapData() {
      this.mapLoading = true;
      FetchMap()
        .then(({ code, result, message }) => {
          if (code === 1 && result) {
            this.mapChartData = {
              companyList: converData(this.bottomLeftChartData || []),
              freezerList: handleMapData(result.freezerLonLatList || []),
              storageList: handleMapData(result.storageLonLatList || []),
              vehicleList: converData(this.vehicleNumData || [])
            };
          } else {
            this.errorMessage(message || "获取地图数据数据失败");
          }
        })
        .catch(err => {
          console.log(err);
          this.errorMessage("获取地图数据数据失败");
        })
        .finally(() => {
          this.mapLoading = false;
          this.initMapChart("", "", this.mapChartData);
        });
    },

    // 获取地图下钻二级市，区，县数据
    fetchCenterCompanyData(cityName = "") {
      this.mapLoading = true;
      FetchCompanyInfoByCity({
        cityName
      })
        .then(({ code, result }) => {
          if (code === 1 && result) {
            this.mapChartData = {
              companyList: handleCityData(result.companyLonLatList || []),
              freezerList: handleMapData(result.freezerLonLatList || []),
              storageList: handleMapData(result.storageLonLatList || []),
              vehicleList: this.filterVehicle(
                handleMapData(result.vehicleLonLatList || [])
              )
            };
          }
        })
        .catch(err => {
          console.log(err);
        })
        .finally(() => {
          this.mapLoading = false;
          this.initMapChart(cityName, "city", this.mapChartData);
        });
    },

    // 初始化中部地图
    initMapChart(cityName = "", mapBoard = "", data = {}) {
      if (this.mapChartInstance) {
        this.mapChartInstance.clear();
      } else {
        this.mapChartInstance = Echarts.init(this.$refs.mapChartDOM);
      }
      const mapChartData = data;
      let legendName = ["入驻企业", "冷库", "车辆", "冷柜"];
      let selected = {
        入驻企业: true,
        冷库: false,
        车辆: false,
        冷柜: false
      };
      const option = {
        legend: {
          data: legendName,
          orient: "horizontal",
          selected: selected,
          textStyle: {
            color: "#666"
          },
          bottom: 10,
          right: 532
        },
        tooltip: {
          show: true
        },
        geo: {
          name: cityName + "inlineMap",
          type: "map",
          map: cityName + "inlineMap",
          roam: true,
          zoom: 1,
          top: 0,
          bottom: "1%",
          tooltip: {
            show: false
          },
          label: {
            normal: {
              show: true,
              position: "inside", //显示位置
              offset: [0, 0], //偏移设置
              color: "#e7e8fd",
              // formatter: "{b}", //圆环显示文字
              fontWeight: "lighter",
              fontSize: 12
            },
            emphasis: {
              color: "#ffffff",
              show: true
            }
          },
          itemStyle: {
            normal: {
              borderColor: "#fff",
              borderWidth: 1,
              areaColor: {
                x: 1000,
                y: 1000,
                x2: 1000,
                y2: 0,
                colorStops: [
                  {
                    offset: 0,
                    color: "#2031f4" // 0% 处的颜色
                  },
                  {
                    offset: 1,
                    color: "#232bd4" // 50% 处的颜色
                  }
                ],
                global: true // 缺省为 false
              }
            },
            emphasis: {
              areaColor: "#131dc1"
            }
          }
        },
        series: [
          {
            name: "入驻企业",
            type: "scatter",
            coordinateSystem: "geo",
            hoverAnimation: true,
            itemStyle: {
              color: "#ff9600" //波纹圈颜色
            },
            emphasis: {
              itemStyle: {
                opacity: 1
              }
            },
            tooltip: {
              show: true,
              formatter: params => {
                let result = "<div>" + params.name + "</div>";
                result +=
                  '<span style="display:inline-block;margin-right:5px;margin-bottom:2px;border-radius:10px;width:9px;height:9px;background-color:' +
                  params.color +
                  '"></span>';
                result += params.seriesName + "：" + params.value[2] + "<br>";
                return result;
              }
            },
            data: mapChartData.companyList
          },
          {
            name: "冷库",
            type: "scatter",
            coordinateSystem: "geo",
            hoverAnimation: true,
            itemStyle: {
              color: "#00b7f4"
            },
            emphasis: {
              itemStyle: {
                opacity: 1
              }
            },
            tooltip: {
              show: true,
              formatter: params => {
                let result = "";
                result +=
                  '<span style="display:inline-block;margin-right:5px;margin-bottom:2px;border-radius:10px;width:9px;height:9px;background-color:' +
                  params.color +
                  '"></span>';
                result += params.seriesName + "：" + params.name + "<br>";
                return result;
              }
            },
            data: mapChartData.storageList
          },
          {
            name: "车辆",
            type: "scatter",
            coordinateSystem: "geo",
            hoverAnimation: true,
            itemStyle: {
              color: "#fc3b85"
            },
            tooltip: {
              show: true,
              formatter: params => {
                let result = "<div>" + params.name + "</div>";
                result +=
                  '<span style="display:inline-block;margin-right:5px;margin-bottom:2px;border-radius:10px;width:9px;height:9px;background-color:' +
                  params.color +
                  '"></span>';
                result += params.seriesName + "：" + params.value[2] + "<br>";
                return result;
              }
            },
            data: mapChartData.vehicleList
          },
          {
            name: "冷柜",
            type: "scatter",
            coordinateSystem: "geo",
            hoverAnimation: true,
            itemStyle: {
              color: "#01af3c"
            },
            emphasis: {
              itemStyle: {
                opacity: 1
              }
            },
            tooltip: {
              show: true,
              formatter: params => {
                let result = "";
                result +=
                  '<span style="display:inline-block;margin-right:5px;margin-bottom:2px;border-radius:10px;width:9px;height:9px;background-color:' +
                  params.color +
                  '"></span>';
                if (params.data.subsetName) {
                  result += params.seriesName + "：" + params.name + "<br />";
                  result += params.data.subsetName;
                } else {
                  result += params.seriesName + "：" + params.name + "<br />";
                }
                return result;
              },
              extraCssText: "width:300px; white-space:pre-wrap" // 额外添加到浮层的css样式，用于换行。
            },
            data: mapChartData.freezerList
          }
        ]
      };
      // for (let keys in mapChartData) {
      //   if (mapChartData[keys].length === 0) {
      //     switch (keys) {
      //       case "companyList":
      //         {
      //           this.delShowPoint("入驻企业", option);
      //         }
      //         break;
      //       case "storageList":
      //         {
      //           this.delShowPoint("冷库", option);
      //         }
      //         break;
      //       case "vehicleList":
      //         {
      //           this.delShowPoint("冷藏车", option);
      //         }
      //         break;
      //       case "freezerList":
      //         {
      //           this.delShowPoint("冷柜", option);
      //         }
      //         break;
      //       default:
      //         break;
      //     }
      //   }
      // }
      // 市级不显示车辆
      // if (mapBoard == "city" && legendName.indexOf("车辆") >= 0) {
      //   this.delShowPoint("车辆", option);
      // }
      this.mapChartInstance.setOption(option);
      this.mapChartInstance.on("click", this.dropdown);
      this.isGoDown && this.mapChartInstance.on("dblclick", this.dropUp);
      // 自动轮播
      clearInterval(this.mapChartHighlightTimer);
      let highlightIndex = 0;
      this.mapChartHighlightTimer = setInterval(() => {
        highlightIndex < legendName.length - 1
          ? highlightIndex++
          : (highlightIndex = 0);
        legendName.forEach((v, i) => {
          option.legend.selected[v] = highlightIndex === i ? true : false;
        });
        this.mapChartInstance.setOption(option);
      }, 2e3);

      // 点击图例切换清除定时器
      this.mapChartInstance.on("legendselectchanged", () => {
        clearInterval(this.mapChartHighlightTimer);
      });
      // 鼠标悬浮地图和离开地图控制切换
      this.mapChartInstance.on("mouseover", () => {
        clearInterval(this.mapChartHighlightTimer);
      });
      this.mapChartInstance.on("mouseout", () => {
        clearInterval(this.mapChartHighlightTimer);
        this.mapChartHighlightTimer = setInterval(() => {
          highlightIndex < legendName.length - 1
            ? highlightIndex++
            : (highlightIndex = 0);
          legendName.forEach((v, i) => {
            option.legend.selected[v] = highlightIndex === i ? true : false;
          });
          this.mapChartInstance.setOption(option);
        }, 2e3);
      });
    },
    // 删除无数据类型显示
    delShowPoint(name, option) {
      let index = option.legend.data.indexOf(name);
      Reflect.deleteProperty(option.legend.selected, name);
      option.legend.data.splice(index, 1);
      option.series.splice(index, 1);
    },
    // 下钻城市
    async dropdown(params) {
      if (params.componentType === "series") return;
      if (
        !this.isGoDown ||
        params.name === "广东省" ||
        params.name === "东沙群岛"
      )
        return;
      // if (!this.isGoDown) return;
      let code = this.conversion(params.name);

      let json = await import(`@/assets/geo/guangdong/couties/${code}.json`);
      // let geoPromises = [import(`@/assets/geo/zhengzhou/inline.json`)];
      // let [inlineGeo] = await Promise.all(geoPromises);
      // 初始化地图
      Echarts.registerMap(params.name + "inlineMap", json);
      this.fetchCenterCompanyData(params.name);
      this.isGoDown = false;
    },

    // 返回上一层
    dropUp() {
      this.fetchCenterMapData();
      this.isGoDown = true;
    },

    conversion(name) {
      let code = 0;
      switch (name) {
        case "湛江市":
          code = 440800;
          break;
        case "茂名市":
          code = 440900;
          break;
        case "阳江市":
          code = 441700;
          break;
        case "江门市":
          code = 440700;
          break;
        case "云浮市":
          code = 445300;
          break;
        case "珠海市":
          code = 440400;
          break;
        case "中山市":
          code = 442000;
          break;
        case "佛山市":
          code = 440600;
          break;
        case "肇庆市":
          code = 441200;
          break;
        case "深圳市":
          code = 440300;
          break;
        case "东莞市":
          code = 441900;
          break;
        case "广州市":
          code = 440100;
          break;
        case "清远市":
          code = 441800;
          break;
        case "惠州市":
          code = 441300;
          break;
        case "韶关市":
          code = 440200;
          break;
        case "汕尾市":
          code = 441500;
          break;
        case "河源市":
          code = 441600;
          break;
        case "揭阳市":
          code = 445200;
          break;
        case "梅州市":
          code = 441400;
          break;
        case "汕头市":
          code = 440500;
          break;
        case "潮州市":
          code = 445100;
          break;
        default:
          code = 440100;
      }
      return code;
    },

    // 按照时间重新加载数据
    reloadData() {
      this.chartTimer = setInterval(() => {
        this.queryNumberByRealTime();
        this.queryNumberByAreaName();
      }, this.reloadDataTime);
    },

    // 筛选当前的车辆列表，将不属于当前地图的点过滤掉
    filterVehicle(vehicleList) {
      // 地图轮廓多边形的点的数据
      const polygonPoints = this.mapGuangdongOutlineGeo.features[0].geometry
        .coordinates[0][0];
      let result = null;

      // 过滤掉不属于该地区的点

      result = vehicleList.filter(item => {
        if (this.isInPolygon(item.value, polygonPoints)) {
          return item;
        }
      });
      return result;
      // return vehicleList;
    },

    /**
     * 判断当前点是否再地图 geoJSON 的多边形范围之内
     * @param {array} checkPoint 要判断的经纬度
     * @param {array} polygonPoints geoJSON 中的多边形数据
     * @return {boolean} 返回是否再当前多边形范围之内
     */
    isInPolygon(checkPoint, polygonPoints) {
      let counter = 0;
      let i;
      let xinters;
      let p1, p2;
      let pointCount = polygonPoints.length;
      p1 = polygonPoints[0];

      for (i = 1; i <= pointCount; i++) {
        p2 = polygonPoints[i % pointCount];
        if (
          checkPoint[0] > Math.min(p1[0], p2[0]) &&
          checkPoint[0] <= Math.max(p1[0], p2[0])
        ) {
          if (checkPoint[1] <= Math.max(p1[1], p2[1])) {
            if (p1[0] != p2[0]) {
              xinters =
                ((checkPoint[0] - p1[0]) * (p2[1] - p1[1])) / (p2[0] - p1[0]) +
                p1[1];
              if (p1[1] == p2[1] || checkPoint[1] <= xinters) {
                counter++;
              }
            }
          }
        }
        p1 = p2;
      }
      if (counter % 2 == 0) {
        return false;
      } else {
        return true;
      }
    },

    // 计算渐变颜色
    calcGradualChangeColor(index, length, startColor, endColor) {
      const rColor =
        startColor[0] + ((endColor[0] - startColor[0]) / length) * index;
      const gColor =
        startColor[1] + ((endColor[1] - startColor[1]) / length) * index;
      const bColor =
        startColor[2] + ((endColor[2] - startColor[2]) / length) * index;

      return `rgb(${rColor}, ${gColor}, ${bColor})`;
    },

    // 计算横向尺寸百分比
    calcXDirectionSizeByPercent(size) {
      return size;
      // 目前此页面不需要自适应，则注释下计算字体
      // return (size / 1920) * this.clientWidth;
    },

    // 计算纵向向尺寸百分比
    calcYDirectionSizeByPercent(size) {
      return size;
      // 目前此页面不需要自适应，则注释下计算字体
      // return (size / 1080) * this.clientHeight;
    }
  }
};
</script>

<style lang="scss" scoped>
@font-face {
  font-family: "LEDNumber";
  src: url(../../../assets/ledFont/LEDNum.eot); /***兼容ie9***/
  src: url(../../../assets/ledFont/LEDNum.eot?#iefix)
      format("embedded-opentype"),
    /***兼容ie6-ie8***/ url("../../../assets/ledFont/LEDNum.woff")
      format("woff"),
    local("LEDNum"), url("../../../assets/ledFont/LEDNum.woff"); /***默认使用本地的***/
}

$layout-width: 1920px;
$layout-height: 1080px;
.echart-wrap {
  background-color: #fff;
  border-radius: 4px;
  box-shadow: 0 2px 12px rgba(209, 213, 217, 0.25);
}
.monitor-container {
  position: relative;
  width: 100%;
  height: 100%;
  background-color: #ecf1f5;

  background-repeat: no-repeat;
  background-size: 100% 100%;

  /*标题*/
  .title-section {
    position: absolute;
    left: 0;
    top: 0;
    right: 0;
    z-index: 2;
    box-sizing: border-box;
    width: 100%;
    height: 83px;
    padding-top: 14px;
    // background-image: url("../../../assets/images/bigScreen/bigScreenTitleBg.png");
    background-repeat: no-repeat;
    background-size: 100% 100%;
    background-position: center center;

    p {
      margin: 0;
    }

    .titleInfo {
      font-family: "LEDNumber";
      color: #3f83ff;
      font-size: 22px;
      word-spacing: 1em;
      margin-left: 35px;
    }

    .titleText {
      width: 359px;
      height: 30px;
      margin: 0 auto;
      // background-image: url("../../../assets/images/bigScreen/bigScreenTitle.png");
      background-repeat: no-repeat;
      background-size: 100% 100%;
      background-position: center center;
    }

    .fullScreen {
      color: rgba(255, 255, 255, 0.5);
      font-size: 30px;
      cursor: pointer;
      margin-top: -35px;
      margin-right: 10px;
    }
  }

  .main {
    position: absolute;
    left: 0;
    right: 0;
    top: 0;
    bottom: 0;
    box-sizing: border-box;
    width: 100%;
    height: 100%;

    p {
      margin: 0;
    }

    .chartPanel {
      &-child {
        position: absolute;
        background-repeat: no-repeat;
        background-size: 100% 100%;

        &.topLeft {
          left: (12px / $layout-width) * 100%;
          top: (20px / $layout-height) * 100%;
          width: (522px / $layout-width) * 100%;
          height: (347px / $layout-height) * 100%;
          @extend .echart-wrap;
        }

        &.topCenter {
          left: 0;
          right: 0;
          top: (20px / $layout-height) * 100%;
          // margin: 0 auto;
          width: (1385px / $layout-width) * 100%;
          height: (1030px / $layout-height) * 100%;

          .dataBubbleList {
            width: 140px;
            // display: flex;
            // justify-content: space-around;
            padding-top: 38px;
            position: absolute;
            left: (50px / $layout-height) * 100%;
            .dataBubble {
              cursor: pointer;
              font-weight: bolder;

              &__header {
                color: #68696b;
                font-size: 16px;
                font-weight: bold;
                text-align: center;
              }
              &__content {
                width: 100px;
                height: 100px;
                margin: -13px auto 0 auto;
                border-radius: 50%;
                line-height: 100px;
                text-align: center;
                font-size: 42px;
              }
              &:nth-child(1) {
                .dataBubble__content {
                  color: #ff9600;
                }
              }
              &:nth-child(2) {
                .dataBubble__content {
                  // color: #6427ff;
                  color: #fc3b85;
                }
              }
              &:nth-child(3) {
                .dataBubble__content {
                  color: #00b7f4;
                }
              }
              &:nth-child(4) {
                .dataBubble__content {
                  color: #01af3c;
                }
              }
            }
          }
          .center-middle-wrap {
            margin: 0 15px;
            height: 100%;
            @extend .echart-wrap;
          }
        }

        &.topRight {
          right: (12px / $layout-width) * 100%;
          top: (20px / $layout-height) * 100%;
          width: (522px / $layout-width) * 100%;
          height: (347px / $layout-height) * 100%;
          @extend .echart-wrap;
        }

        &.middleLeft {
          left: (12px / $layout-width) * 100%;
          top: (382px / $layout-height) * 100%;
          width: (522px / $layout-width) * 100%;
          height: (320px / $layout-height) * 100%;
          @extend .echart-wrap;
        }

        &.middleCenter {
          margin: 0 auto;
          width: calc(100% - 60px);
          padding: 20px;
          box-sizing: border-box;
          // height: calc(100% - 144px);
          height: 100%;
        }

        &.middleRight {
          right: (12px / $layout-width) * 100%;
          top: (382px / $layout-height) * 100%;
          width: (522px / $layout-width) * 100%;
          height: (320px / $layout-height) * 100%;
          @extend .echart-wrap;
        }

        &.bottomLeft {
          left: (12px / $layout-width) * 100%;
          top: (716px / $layout-height) * 100%;
          width: (672px / $layout-width) * 100%;
          height: (334px / $layout-height) * 100%;
          @extend .echart-wrap;
        }

        &.bottomCenter {
          // left: 0px;
          right: (552px / $layout-width) * 100%;
          top: (706px / $layout-height) * 100%;
          // margin: 0 auto;
          width: (600px / $layout-width) * 100%;
          height: (334px / $layout-height) * 100%;
          box-sizing: border-box;
          padding: 0 40px;

          .el-carousel {
            height: 100%;
            padding: 0 10px;
            @extend .echart-wrap;
          }

          .chartPanel__table {
            width: 100%;
            height: 100%;
            font-size: 14px;
            border-collapse: collapse;
            text-align: center;
            color: #666;
            .th-color {
              color: #666;
              font-weight: bold;
            }
            thead {
              height: 42px;
              tr {
                border-bottom: 2px solid #0288ff;
              }
            }
            tbody {
              tr:nth-child(odd) {
                background-color: #d7edfb;
              }
              tr:nth-child(even) {
                background-color: #fff;
              }
            }
            tr {
              height: 30px;
              line-height: 30px;
              th {
                width: 20%;
                line-height: 41px;
              }
              td {
                width: 20%;
                line-height: 30px;
              }
            }
          }
        }

        &.bottomRight {
          right: (12px / $layout-width) * 100%;
          top: (716px / $layout-height) * 100%;
          width: (522px / $layout-width) * 100%;
          height: (334px / $layout-height) * 100%;
          @extend .echart-wrap;
        }

        &-slide {
          position: absolute;
          top: 7px;
          right: 25px;
          display: flex;
          z-index: 10;

          li {
            margin-left: 3px;
            padding: 5px 6px;
            font-size: 12px;
            color: #3d3d3d;
            transition: all 0.3s;
            cursor: pointer;

            &:hover {
              color: #3d3d3d;
              background: #c2d8f9;
              border-radius: 5px;
            }
            &.active {
              color: #fff;
              background: #2487fe;
              border-radius: 5px;
            }
          }
        }

        &-chartArea {
          position: absolute;
          left: 0;
          right: 0;
          top: 0;
          bottom: 0;
          width: 100%;
          height: 100%;
        }
      }
    }
  }
}
</style>
